import { render, staticRenderFns } from "./addEditItem.vue?vue&type=template&id=78c15f55&scoped=true&"
import script from "./addEditItem.vue?vue&type=script&lang=js&"
export * from "./addEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c15f55",
  null
  
)

export default component.exports